var _a;
import { immerable } from 'immer';
var SelectedWork = /** @class */ (function () {
    function SelectedWork() {
        this[_a] = true;
        this.selectedWorks = [];
    }
    Object.defineProperty(SelectedWork.prototype, "works", {
        get: function () {
            return this.selectedWorks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectedWork.prototype, "unavailableCourseWorks", {
        get: function () {
            return this.selectedWorks.filter(function (selectedWork) { return selectedWork.unavailableCourse; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectedWork.prototype, "unavailableWork", {
        get: function () {
            return this.selectedWorks.filter(function (work) { return !work.available; });
        },
        enumerable: false,
        configurable: true
    });
    SelectedWork.prototype.initialize = function (works) {
        this.selectedWorks = works;
    };
    SelectedWork.prototype.unselect = function (work) {
        var index = this.selectedWorks.findIndex(function (selectedWodk) { return selectedWodk.id === work.id; });
        if (index !== -1) {
            this.selectedWorks.splice(index, 1);
        }
    };
    SelectedWork.prototype.select = function (work) {
        this.selectedWorks.push(work);
    };
    SelectedWork.prototype.clear = function () {
        this.selectedWorks = [];
    };
    return SelectedWork;
}());
_a = immerable;
export function createSelectedWorks() {
    return new SelectedWork();
}
